import { Regions } from 'common/model/account/regions';
import React, { useLayoutEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { clientCurrentRegionSelector } from 'redux/selectors';

// here happens changes in the static UI depending on the state
export const UiControllerService: React.FC = () => {
    const currentRegion = useSelector(clientCurrentRegionSelector);
    console.log('currentRegion', currentRegion);
    const chatwootBtnElement = useRef<HTMLElement | null>(null);
    const chatwootBubbleElement = useRef<HTMLElement | null>(null);
    const chatwootHolderElement = useRef<HTMLElement | null>(null);

    useLayoutEffect(() => {
        if (!chatwootBtnElement.current) {
            chatwootBtnElement.current = document.getElementById('chat_woot_widget');
        }
        if (!chatwootBubbleElement.current) {
            chatwootBubbleElement.current = document.querySelector('.woot--bubble-holder');
        }
        if (!chatwootHolderElement.current) {
            chatwootHolderElement.current = document.querySelector('.woot-widget-holder');
        }

        if (currentRegion === Regions.UGRA && chatwootBtnElement.current)
        {
            chatwootBtnElement.current.style.display = 'none';
            if (chatwootBubbleElement.current && chatwootHolderElement.current) {
                chatwootBubbleElement.current.style.display = 'none';
                chatwootHolderElement.current.style.display = 'none';

            }
        } else if (chatwootBtnElement.current)
        {
            chatwootBtnElement.current.style.display = 'block';
            if (chatwootBubbleElement.current && chatwootHolderElement.current) {
                chatwootBubbleElement.current.style.display = 'block';
                chatwootHolderElement.current.style.display = 'block';
            }
        }
    }, [currentRegion]);

    return null;
};
